'use client'

// The ground he stands on: the terrain's height field with the raised
// floors laid over it (WALK_ surfaces in obstacles.glb: the tube
// carriage's floor, a metre up, and the pallets at its door, 30 Oct).
// The live bird, the director's puppet and the director's camera all take
// their ground from this, so he is drawn on the carriage floor and not a
// metre under it, in the town and on the director's set alike. A visitor
// walking (FirstPersonController) already stood on these.

import { useMemo } from 'react'
import { useObstacles } from '../obstacles/ObstacleProvider'
import { walkableTopAt } from '../../../lib/obstacles/loadObstacles'

/** `terrain` (from useTerrainHeight) with `sample` raised onto any floor at (x, z); null while it loads. */
export function useWithFloors(terrain) {
  const { walkables } = useObstacles()
  return useMemo(() => {
    if (!terrain || !walkables?.length) return terrain
    return { ...terrain, sample: (x, z) => Math.max(terrain.sample(x, z), walkableTopAt(walkables, x, z)) }
  }, [terrain, walkables])
}
